const CLEAR_EVENT = "clear-zconnect-app-session";

// Optional: lock this down to your real parent origin(s) in production,
// e.g. ["https://parent-app.com"]. Leave empty to accept any origin.
const ALLOWED_PARENT_ORIGINS: string[] = [];

function clearZConnectSession() {
  try {
    sessionStorage.clear();
    localStorage.clear();
  } catch (err) {
    console.error("Failed to clear zConnect storage", err);
  }
}

/**
 * Registers a postMessage listener so the parent app (which embeds zConnect in
 * an iframe) can wipe all of zConnect's local/session storage on demand.
 *
 * Parent triggers it with:
 *   iframe.contentWindow.postMessage(
 *     { type: "clear-zconnect-app-session" },
 *     "*", // or the zConnect origin
 *   );
 *
 * Note: sessionStorage is shared across same-origin iframes in the same tab,
 * so this clears every open zConnect iframe, not just one.
 */
export function listenForParentSessionClear() {
  window.addEventListener("message", (event: MessageEvent) => {
    if (
      ALLOWED_PARENT_ORIGINS.length > 0 &&
      !ALLOWED_PARENT_ORIGINS.includes(event.origin)
    ) {
      return;
    }

    // Accept either { type: "..." } or the bare string form.
    const type = typeof event.data === "string" ? event.data : event.data?.type;

    if (type === CLEAR_EVENT) {
      clearZConnectSession();
    }
  });
}
